module.exports = __webpack_public_path__ + "static/media/ingredients-rice.23bdfc9a.png";